<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
    <div class="col-md-12 mx-auto">
        <h3>Reportes</h3>
    </div>
    <hr />

    <div class="col-sm-12 col-md-12 col-lg-12 mx-auto">
        <div class="mt-2 mb-2">
            <div *ngIf="flagErrors" class="alert alert-danger" role="alert">
                {{ message }}
            </div>
        </div>
        <form [formGroup]="reportForm" (ngSubmit)="getReportInformation()" novalidate>
            <div class="row">
                <div class="col-md-4">
                    <div class="mb-3 form-floating">
                        <select class="form-select"
                            aria-label="Floating label select"
                            id="officeId"
                            name="officeId"
                            formControlName="officeId"
                            [ngClass]="{
                                'is-invalid': flagErrors && submitted && f.officeId.errors,
                                'is-valid': !flagErrors && submitted && !f.officeId.errors
                            }"
                        >
                            <option selected value="">Selecciona una sucursal</option>
                            <option value="{{ office.id }}" *ngFor="let office of offices">
                                {{ office.name }}
                            </option>
                        </select>
                        <label for="select_state" class=""> Selecciona una sucursal </label>
                        <div>
                            <div *ngIf="flagErrors && f.officeId?.invalid && (f.officeId?.errors || f.officeId?.touched)">
                                <div class="ms-2 text-danger" *ngIf="f.officeId?.errors.required && submitted">
                                    Sucursal obligatoria, seleccione uno.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 form-floating">
                    <div class="input-group">
                        <input type="text"
                            name="startDate"
                            class="form-control"
                            id="startDate"
                            formControlName="startDate"
                            placeholder="Fecha de inicio"
                            ngbDatepicker
                            [minDate]="{ year: 1950, month: 1, day: 1 }"
                            #dpStart="ngbDatepicker"
                            readonly
                            style="height: 3.5rem"
                        />
                        <button class="btn btn-outline-secondary bi bi-calendar3"
                            (click)="dpStart.toggle()"
                            type="button">
                        </button>
                    </div>
                </div>
                <div class="col-md-4 form-floating">
                    <div class="input-group">
                        <input type="text"
                            name="endDate"
                            class="form-control"
                            id="endDate"
                            formControlName="endDate"
                            placeholder="Fecha de finalización"
                            ngbDatepicker
                            [minDate]="{ year: 1950, month: 1, day: 1 }"
                            #dpEnd="ngbDatepicker"
                            readonly
                            style="height: 3.5rem"
                        />
                        <button
                            class="btn btn-outline-secondary bi bi-calendar3"
                            (click)="dpEnd.toggle()"
                            type="button">
                        </button>
                    </div>
                </div>
            </div>
            <div class="mb-3 mt-2 d-grip gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-danger" (click)="resetReportData()">
                    <i class="bi bi-eraser"></i>
                    Limpiar busqueda
                </button>
                <button type="submit" class="btn btn-success">
                    <i class="bi bi-clipboard-check"></i>
                    Obtener informaci&oacute;n
                </button>
            </div>
        </form>
    </div>
    <hr />

    <div class="row" *ngIf="sells.length !== 0">
        <div class="card">
            <div class="card-header">Total de Ventas</div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3">
                        <div class="row">Total de paquetes vendidos</div>
                        <div class="row fw-bold">{{ sells.totalPackages }}</div>
                    </div>
                    <div class="col-md-3">
                        <div class="row">Total de ventas</div>
                        <div class="row fw-bold">{{ sells.totalVenta | currency }}</div>
                    </div>
                    <div class="col-md-3">
                        <div class="row">Total de anticipos</div>
                        <div class="row fw-bold">{{ sells.totalAnticipo | currency }}</div>
                    </div>
                    <div class="col-md-3">
                        <div class="row">Restante total a pagar</div>
                        <div class="row fw-bold">{{ sells.totalDeuda | currency }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-3" *ngIf="packages.length !== 0">
        <div class="card">
            <div class="card-header">
                <div class="row d-flex justify-content-center align-items-center">
                    <div class="col-md-6">Informacion de paquetes vendidos</div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-8">
                                <select class="form-select"
                                    #colaboratorSelect
                                    aria-label="Floating label select"
                                    id="colaboratorId"
                                    name="colaboratorId"
                                    (change)="filterPerUser(colaboratorSelect)"
                                >
                                    <option selected value="">Filtra por colaborador(a)</option>
                                    <option [value]="user.id" *ngFor="let user of users">
                                        {{ user.first_name }} {{ user.last_name }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <button type="button" class="btn btn-danger" (click)="resetPackagesSearch(colaboratorSelect)">
                                    Limpiar filtro
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="text-center">Colaborador</th>
                            <th class="text-center">Cliente</th>
                            <th class="text-center">Tipo de paquete</th>
                            <th class="text-center">Precio</th>
                            <th class="text-center">Anticipo</th>
                            <th class="text-center">Resto a pagar</th>
                            <th class="text-center">Cita</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let package of filterPackages">
                            <td class="text-center">{{ package.employee.name }}</td>
                            <td class="text-center">{{ package.client.name }}</td>
                            <td class="text-center">{{ package.typePackage }}</td>
                            <td class="text-center">{{ package.realPrice | currency }}</td>
                            <td class="text-center">{{ package.advance | currency }}</td>
                            <td class="text-center">{{ package.remaining | currency }}</td>
                            <td class="text-center" *ngIf="package.hasRemaining == 0 && package.hasSessions == 0" class="text-success text-center">Si</td>
                            <td class="text-center" *ngIf="package.hasRemaining == 0 && package.hasSessions == 1" class="text-success text-center">No</td>
                            <td class="text-center" *ngIf="package.hasRemaining == 1 && package.hasSessions == 1" class="text-success text-center">Si</td>
                            <td class="text-center" *ngIf="package.hasRemaining == 1 && package.hasSessions == 0" class="text-danger text-center">No</td>
                        </tr>
                        <tr>
                            <td colspan="7">&nbsp;</td>
                        </tr>
                        <tr>
                            <td class="text-center" colspan="3">&nbsp;</td>
                            <td class="text-center">{{ sells.totalVenta | currency }}</td>
                            <td class="text-center">{{ sells.totalAnticipo | currency }}</td>
                            <td class="text-center">{{ sells.totalDeuda | currency }}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="row mt-3" *ngIf="paymentsSessions.length !== 0">
        <div class="card">
            <div class="card-header">Pago en sesiones</div>
            <div class="card-body">
                <div class="row">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th class="text-center">Cliente</th>
                                <th class="text-center">Tipo</th>
                                <th class="text-center"># Sesion</th>
                                <th class="text-center">Fecha</th>
                                <th class="text-center">Total</th>
                                <th class="text-center">Metodo de pago</th>
                                <th class="text-center">Ofertas de pago</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let paymentSession of paymentsSessions">
                                <td class="text-center">{{ paymentSession.session.client }}</td>
                                <td class="text-center">{{ paymentSession.session.type }}</td>
                                <td class="text-center">{{ paymentSession.session.numberSession }}</td>
                                <td class="text-center">{{ paymentSession.session.dateSession }}</td>
                                <td class="text-center">{{ paymentSession.amount | currency }}</td>
                                <td class="text-center">
                                {{
                                    paymentSession.paymentMethod.id
                                    ? paymentSession.paymentMethod.name
                                    : "-"
                                }}
                                </td>
                                <td class="text-center">
                                {{
                                    paymentSession.payments.id
                                    ? paymentSession.payments.name
                                    : "-"
                                }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-3" *ngIf="paymentsSessionsAppt.length !== 0">
        <div class="card">
            <div class="card-header">Pagos extras</div>
            <div class="card-body">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="text-center">Cliente</th>
                            <th class="text-center">Tipo de paquete</th>
                            <th class="text-center">Total</th>
                            <th class="text-center">Descripcion</th>
                            <th class="text-center">Metodo de pago</th>
                            <th class="text-center">Ofertas de pago</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let extras of paymentsSessionsAppt">
                            <td class="text-center">{{ extras.appt.client }}</td>
                            <td class="text-center">{{ extras.appt.type }}</td>
                            <td class="text-center">{{ extras.amount | currency }}</td>
                            <td class="text-center">{{ extras.extra }}</td>
                            <td class="text-center">
                                {{ extras.paymentMethod.id ? extras.paymentMethod.name : "-" }}
                            </td>
                            <td class="text-center">{{ extras.payments.id ? extras.payments.name : "-" }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="row mt-3 mb-4" *ngIf="employeesInfo.length !== 0">
        <div class="card">
            <div class="card-header">Informacion de colaboradores</div>
            <div class="card-body">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="text-center">Nombre del colaborador</th>
                            <th class="text-center">Email del colaborador</th>
                            <th class="text-center">Rol del colaborador</th>
                            <th class="text-center">Total de ventas</th>
                            <th class="text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let employee of employeesInfo">
                            <td class="text-center">{{ employee.name }}</td>
                            <td class="text-center">{{ employee.email }}</td>
                            <td class="text-center">{{ employee.role }}</td>
                            <td class="text-center">
                                {{ employee.packagesInfo.length }}
                                {{
                                employee.packagesInfo.length === 1 ? "paquete" : "paquetes"
                                }}
                            </td>
                            <td class="text-center">
                                <a
                                (click)="
                                    openDetailsModal(employee.packagesInfo, employee.name)
                                "
                                placement="top"
                                ngbTooltip="Ver detalles"
                                role="button"
                                class="btn btn-success"
                                >
                                <i class="bi bi-eye-fill"></i>
                                Ver detalles
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<ng-template #detailsInfo let-close="close">
    <div class="modal-header">
        <h4 class="modal-title">
            Informacion detallada de {{ nameEmployeeSelected }}
        </h4>
        <button class="close ms-auto modal-close-btn" type="button" (click)="close()">
            <i class="bi bi-x-lg"></i>
        </button>
    </div>
    <div *ngIf="customPackages.length === 0"
        class="alert alert-danger"
        role="alert">
            No hay informaci&oacute;n de venta de paquetes de
            {{ nameEmployeeSelected }}.
    </div>
    <div *ngIf="customPackages.length > 0">
        <div class="modal-body">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="text-center">Cliente</th>
                        <th class="text-center">Tipo de paquete</th>
                        <th class="text-center">Precio</th>
                        <th class="text-center">Numero de sesiones</th>
                        <th class="text-center">Porcentaje de descuento</th>
                        <th class="text-center">Anticipo</th>
                        <th class="text-center">Resto a pagar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let details of customPackages">
                        <td class="text-center">{{ details.client }}</td>
                        <td class="text-center">{{ details.typePackageName }}</td>
                        <td class="text-center">{{ details.price | currency }}</td>
                        <td class="text-center">{{ details.totalSessions }}</td>
                        <td class="text-center">{{ details.percentage }} %</td>
                        <td class="text-center">{{ details.advance | currency }}</td>
                        <td class="text-center">{{ details.remaining | currency }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-template>
